// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_bm-4";
export var collapsed = "_bm-1";
export var headerBar = "_bm-0";
export var leftHeaderContent = "_bm-3";
export var subjectContainer = "_bm-2";